import React from 'react';
import { XMarkIcon as XIcon } from '@heroicons/react/24/solid';

const TagBadge = ({ 
  name, 
  onRemove, 
  className = '',
  interactive = true,
  color = '#3B82F6' // Default to Tailwind's blue-500
}) => {
  // Convert hex color to RGB for computing lighter/darker shades
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };

  // Calculate relative luminance
  const getLuminance = (r, g, b) => {
    const [rs, gs, bs] = [r, g, b].map(c => {
      c = c / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
  };

  const rgb = hexToRgb(color) || { r: 59, g: 130, b: 246 }; // Default to blue-500
  const luminance = getLuminance(rgb.r, rgb.g, rgb.b);
  const textColor = luminance > 0.5 ? '#000000' : '#FFFFFF';
  const bgColor = color;
  const hoverBgColor = rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.8)` : 'rgba(59, 130, 246, 0.8)';
  return (
    <span 
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
        ${className}
      `}
      style={{
        backgroundColor: bgColor,
        color: textColor,
        ...(interactive && {
          ':hover': {
            backgroundColor: hoverBgColor
          }
        })
      }}
    >
      {name}
      {interactive && onRemove && (
        <button
          type="button"
          className="flex-shrink-0 ml-1 h-4 w-4 rounded-full inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-1"
          style={{
            color: textColor,
            ':hover': {
              backgroundColor: hoverBgColor
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(name);
          }}
        >
          <span className="sr-only">Remove {name} tag</span>
          <XIcon className="h-3 w-3" aria-hidden="true" />
        </button>
      )}
    </span>
  );
};

export default React.memo(TagBadge);
